import { render, staticRenderFns } from "./BorderMapComponent.vue?vue&type=template&id=6b640980&scoped=true&"
import script from "./BorderMapComponent.vue?vue&type=script&lang=js&"
export * from "./BorderMapComponent.vue?vue&type=script&lang=js&"
import style0 from "./BorderMapComponent.vue?vue&type=style&index=0&id=6b640980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b640980",
  null
  
)

export default component.exports